module.exports = __webpack_public_path__ + "static/assets/4dcf89c6dc891f51fd9803a5b2d52320.svg";